import {controlSvg as Icon__small__controlSvg} from '../Icon__small/Icon__small--control.js';
import {controlSvg as Icon__xsmall__controlSvg} from '../Icon__xsmall/Icon__xsmall--control.js';

export var control = {
  name: 'control',
  category: 'icon',
  colorable: true,
  svg: Icon__small__controlSvg,
  alt: {
    Icon__small: Icon__small__controlSvg,
    Icon__xsmall: Icon__xsmall__controlSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
